import { BACK_BUTTON } from 'components/common/ActionBar/constants';

export const ActionBarIcons = {
    leftIcons: [BACK_BUTTON],
    centerIcons: [],
    rightIcons: []
};

export const changeConfirmationDialogDefaults = {
    open: true,
    title: 'Discard changes',
    message: 'Are you sure you want to continue?',
    okLabel: 'Discard',
    onCancel: () => undefined,
};
